import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/AdminPanel";
import EventRegister from "@/pages/EventRegister";
import Unsubscribe from "@/pages/Unsubscribe";
import DisciplinePage from "@/pages/DisciplinePage";
import CustomPage from "@/pages/CustomPage";
import NewsDetail from "@/pages/NewsDetail";
import AllNews from "@/pages/AllNews";
import ResetPassword from "@/pages/ResetPassword";
import LiveBoard from "@/pages/LiveBoard";
import DirectorLive from "@/pages/DirectorLive";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import ThemeApplier from "@/components/ThemeApplier";
import UploadProgress from "@/components/UploadProgress";
import Documents from "@/pages/Documents";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
        Caricamento…
      </div>
    );
  if (!user) return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <ThemeApplier />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/tabellone" element={<LiveBoard />} />
            <Route path="/giuria-live" element={<ProtectedRoute><DirectorLive /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/evento/:eventId" element={<EventRegister />} />
            <Route path="/disciplina/:discipline" element={<DisciplinePage />} />
            <Route path="/pagina/:key" element={<CustomPage />} />
            <Route path="/notizia/:id" element={<NewsDetail />} />
            <Route path="/notizie" element={<AllNews />} />
            <Route path="/documenti" element={<Documents />} />
            <Route path="/disiscrizione" element={<Unsubscribe />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <UploadProgress />
      </AuthProvider>
    </div>
  );
}

export default App;
